import { render, staticRenderFns } from "./TagsPage.vue?vue&type=template&id=4ffe73e0&scoped=true&"
import script from "./TagsPage.vue?vue&type=script&lang=js&"
export * from "./TagsPage.vue?vue&type=script&lang=js&"
import style0 from "./TagsPage.vue?vue&type=style&index=0&id=4ffe73e0&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe73e0",
  null
  
)

export default component.exports